import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class PurchaseBillService {

  constructor(private apiService: ApiService, private http: HttpClient) { }

  getPurchaseBills(queryParams?: HttpParams) {
    return this.apiService.get('purchase-bills', queryParams);
  }

  downloadPurchaseBillsZip(data: any) {
    return this.http.post(
      `${environment.apiBaseUrl}purchase-bills/export-zip`, // use apiBaseUrl from environment
      data,
      { responseType: 'blob' }
    );
  }



  cretePurchaseBills(data: any) {
    return this.apiService.post('purchase-bills', data);
  }

  getPurchaseBill(id: any) {
    return this.apiService.get('purchase-bills/' + id);
  }

  updatePurchaseBills(id: any, data: any) {
    return this.apiService.update('purchase-bills/' + id, data);
  }

  deletePurchaseBills(id: any) {
    return this.apiService.delete('purchase-bills/' + id);
  }
}
